import styled from 'styled-components';
import React, { useRef } from 'react';
import { Overview } from '../overview/Overview';

const Main = styled.div`
  position: relative;
  width: 100%;
`;

const Section = styled.section`
  scroll-margin-top: 7.2em;
`;

export const StockDetailsVolumeTab: React.FC = () => {
  const sectionsRef = useRef<Record<string, HTMLDivElement | null>>({});

  return (
    <Main>
      <Section
        id="overviewCSR"
        ref={(el) => (sectionsRef.current['overview'] = el as HTMLDivElement)}
      >
        <Overview />
      </Section>
    </Main>
  );
};
